import ashoka from "./stage9/AshokaLionCapital.png";
import konark from "./stage9/KonarkWheel.png";
import dancingGirl from "./stage9/DancingGirl.png";
import nataraja from "./stage9/Nataraja.png";
import harappanSeal from "./stage9/HarappanSeal.png";
import sanchi from "./stage9/SanchiStupa.png";
import indiaGate from "./stage9/IndiaGate.png";
import constitution from "./stage9/constitutionofindia.png";

/** Points written to DB `stage9` on successful restore. */
export const ARCHIVE_POINTS = 100;

/** Puzzle 4 hotspot unlocked after Museum Archive success. */
export const ARCHIVE_UNLOCKS = "remember_me_if_you_can";

export const ARCHIVE_SUCCESS_COPY = {
  title: "Every artifact has its story back.",
  body: "Only the Memory Wall remains...",
};

/**
 * Artifact display slots — description cards drag beneath these.
 * correctCardId matches DESCRIPTIONS[].id
 */
export const ARTIFACTS = [
  {
    id: "ashoka",
    label: "Ashoka Lion Capital",
    image: ashoka,
    correctCardId: "ashoka",
  },
  {
    id: "konark",
    label: "Konark Wheel",
    image: konark,
    correctCardId: "konark",
  },
  {
    id: "dancing_girl",
    label: "Dancing Girl",
    image: dancingGirl,
    correctCardId: "dancing_girl",
  },
  {
    id: "nataraja",
    label: "Nataraja",
    image: nataraja,
    correctCardId: "nataraja",
  },
  {
    id: "harappan_seal",
    label: "Harappan Seal",
    image: harappanSeal,
    correctCardId: "harappan_seal",
  },
  {
    id: "sanchi",
    label: "Sanchi Stupa",
    image: sanchi,
    correctCardId: "sanchi",
  },
  {
    id: "india_gate",
    label: "India Gate",
    image: indiaGate,
    correctCardId: "india_gate",
  },
  {
    id: "constitution",
    label: "Constitution of India",
    image: constitution,
    correctCardId: "constitution",
  },
];

/** Draggable description plaques (2-line labels to match museum nameplates). */
export const DESCRIPTIONS = [
  {
    id: "ashoka",
    text: "Ashoka Lion Capital\nNational Emblem",
  },
  {
    id: "konark",
    text: "Konark Sun Temple\nStone Wheel",
  },
  {
    id: "dancing_girl",
    text: "Dancing Girl\nIndus Valley Bronze",
  },
  {
    id: "nataraja",
    text: "Nataraja\nCosmic Dance Bronze",
  },
  {
    id: "harappan_seal",
    text: "Harappan Seal\nIndus Valley Script",
  },
  {
    id: "sanchi",
    text: "Sanchi Stupa\nAshokan Monument",
  },
  {
    id: "india_gate",
    text: "India Gate\nWar Memorial, Delhi",
  },
  {
    id: "constitution",
    text: "Constitution of India\n26 January 1950",
  },
];

export function shuffleArray(items) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

/**
 * @param {Record<string, string|null>} placements artifactId → cardId
 */
export function validateArchivePlacements(placements, artifacts = ARTIFACTS) {
  const wrongIds = [];
  const missingIds = [];
  let correctCount = 0;

  artifacts.forEach((artifact) => {
    const placed = placements[artifact.id];
    if (placed == null || placed === "") {
      missingIds.push(artifact.id);
      return;
    }
    if (placed === artifact.correctCardId) {
      correctCount += 1;
    } else {
      wrongIds.push(artifact.id);
    }
  });

  return {
    ok: wrongIds.length === 0 && missingIds.length === 0,
    wrongIds,
    missingIds,
    correctCount,
  };
}

/** Assign card to artifact; swap with origin when dropping onto an occupied slot. */
export function assignCard(
  placements,
  artifactId,
  cardId,
  originArtifact = null
) {
  const next = { ...placements };
  const displaced =
    next[artifactId] != null && next[artifactId] !== cardId
      ? next[artifactId]
      : null;

  Object.keys(next).forEach((id) => {
    if (next[id] === cardId) next[id] = null;
  });

  if (displaced && originArtifact && originArtifact !== artifactId) {
    next[originArtifact] = displaced;
  }

  next[artifactId] = cardId;
  return next;
}

export function clearArtifactSlot(placements, artifactId) {
  return { ...placements, [artifactId]: null };
}

export function unassignedCardIds(placements, cards = DESCRIPTIONS) {
  const used = new Set(
    Object.values(placements).filter((id) => id != null && id !== "")
  );
  return cards.filter((c) => !used.has(c.id)).map((c) => c.id);
}
